import React from "react";
import { MapPinIcon, EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";

export const ContactUs = () => {
  const contactDetails = {
    address:
      "Shree Krishna Academy, Sukhdeo Sumitra path Bala Bigha road Teyar Nawada Bihar (805112)",
    email: "info@skacademy.org.in",
    phone: "+91-9470214758",
    gpsLink:
      "https://www.google.com/maps/place/SHREE+KRISHNA+ACADMY/@24.8022986,85.5038379,13.75z/data=!4m6!3m5!1s0x39f303a200ed700b:0x1ff3506ec0be3ca3!8m2!3d24.7966218!4d85.5069791!16s%2Fg%2F11ts03ys32?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D",
    gpsImage: "/../../assets/gps.JPG",
  };

  return (
    <div className="container mx-auto px-4 py-10">
      {/* Header Section */}
      <div
        className="rounded-xl shadow-lg text-white text-center py-10 bg-cover bg-center mb-10"
        style={{
          backgroundImage: "url('/../../../assets/school_wall_paper.jpeg')",
        }}
      >
        <h2 className="text-4xl font-bold flex items-center justify-center gap-4">
          <MapPinIcon className="h-10 w-10 text-white" />
          Contact Us
        </h2>
      </div>

      {/* Contact Details Section */}
      <div className="bg-white rounded-xl shadow-lg p-6 lg:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left: Contact Details */}
          <div>
            <h3 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <MapPinIcon className="h-6 w-6 text-[#556d89]" />
              Our Address
            </h3>
            <p className="text-gray-700 mb-4">{contactDetails.address}</p>

            <h3 className="text-2xl font-semibold mb-4 flex items-center gap-2">
              <EnvelopeIcon className="h-6 w-6 text-[#556d89]" />
              Email
            </h3>
            <a
              href={`mailto:${contactDetails.email}`}
              className="text-[#556d89] underline hover:text-red-800"
            >
              {contactDetails.email}
            </a>

            <h3 className="text-2xl font-semibold mt-6 mb-4 flex items-center gap-2">
              <PhoneIcon className="h-6 w-6 text-[#556d89]" />
              Phone
            </h3>
            <a
              href={`tel:${contactDetails.phone}`}
              className="text-[#556d89] underline hover:text-red-800"
            >
              {contactDetails.phone}
            </a>
          </div>

          {/* Right: GPS Location */}
          <div className="text-center">
            <h3 className="text-2xl font-semibold mb-4">Visit Us</h3>
            <a
              href={contactDetails.gpsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={contactDetails.gpsImage}
                alt="GPS Location"
                className="rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-transform duration-200"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
